import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
// import './_metronic/assets/sass/style.scss'
// import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/css/style.rtl.css'
import './_metronic/assets/sass/style.react.scss'
// ASA's look (asatsp.ir) on top of the Metronic theme; it must stay after the theme imports.
import './app/theme/asa-theme.css'
// Phones and tablets: the foundation every page shares (2026-10-17).
import './app/theme/asa-responsive.css'
import {AppRoutes} from './app/routing/AppRoutes'
import {AppVersionWatcher} from './app/AppVersionWatcher'
import {AuthProvider, setupAxios} from './app/modules/auth'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import {startInstallPromptCapture} from './app/modules/install-app'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)
// The browser's install offer can come before the signed-in layout exists; keep it for the guide.
startInstallPromptCapture()

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <AppVersionWatcher />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
